<template>
  <div class="jd-section jd-section--shifts">
    <p class="job-section__header">{{ $t('jobDetail.timetable') }}</p>
    <div v-if="showShifts || showDates || showRotationOrSaturdayRequired" class="jd__shifts jd-section__items">
      <job-shift-item
        v-for="(shift, i) in shifts"
        :key="`JobDetailShift${i}`"
        class="jd-section__item jd-section__item--fixed-width"
        :day-groups="shift.dayGroups"
        :end-time="shift.endTime"
        :is-overnight="shift.isOvernight"
        :start-time="shift.startTime"
      />
      <span v-if="showShifts && showDates" class="section-break" />
      <job-shift-date
        v-if="startDate"
        type="start"
        class="jd-section__item jd-section__item--sm jd-section__item--fixed-width"
        :date="startDate"
      />
      <job-shift-date
        v-if="endDate"
        type="end"
        class="jd-section__item jd-section__item--sm jd-section__item--fixed-width"
        :date="endDate"
      />
      <job-shift-rotation
        v-if="showRotationOrSaturdayRequired"
        class="jd-section__item jd-section__item--sm jd-section__item--fixed-width"
        :is-alternative-sat="isAlternativeSat"
        :is-shift-required="isShiftRequired"
      />
    </div>
    <p v-else>{{ $t('general.notAvailable') }}</p>
  </div>
</template>

<script>
import JobShiftDate from '../jobShift/jobShiftDate'
import JobShiftItem from '../jobShift/jobShiftItem'
import JobShiftRotation from '../jobShift/jobShiftRotation'

export default {
  components: {
    'job-shift-date': JobShiftDate,
    'job-shift-item': JobShiftItem,
    'job-shift-rotation': JobShiftRotation,
  },
  computed: {
    showDates() {
      return !!this.startDate && !!this.endDate
    },
    showRotationOrSaturdayRequired() {
      return this.isAlternativeSat || this.isShiftRequired
    },
    showShifts() {
      return this.shifts.length > 0
    },
  },
  props: {
    endDate: {
      default: '',
      type: String,
    },
    isAlternativeSat: {
      default: false,
      type: Boolean,
    },
    isShiftRequired: {
      default: false,
      type: Boolean,
    },
    shifts: {
      default: () => [],
      type: Array,
    },
    startDate: {
      default: '',
      type: String,
    },
  },
}
</script>
